import { INavLink } from './types'
import { IOption } from '../../types/items'

export const SNavLinks: INavLink[] = [
  { linkTo: '/admin', slug: 'home' },
  { linkTo: '/orders', slug: 'orders' },
  { linkTo: '/categories', slug: 'categories' },
  { linkTo: '/booking', slug: 'booking' },
  { linkTo: '/referals', slug: 'referals' },
  { linkTo: '/restaurants', slug: 'restaurants' },
  { linkTo: '/products', slug: 'products' },
  { linkTo: '/feedback', slug: 'feedback' },
  // { linkTo: '/sales', slug: 'sales' },
  { linkTo: '/users', slug: 'users' },
  { linkTo: '/staff', slug: 'staff' },
  { linkTo: '/roles', slug: 'roles' },
  { linkTo: '/archive', slug: 'history' },
  { linkTo: '/delivery', slug: 'delivery' },
  { linkTo: '/notifications', slug: 'notifications' },
  { linkTo: '/stocks', slug: 'stocks' },
  { linkTo: '/settings', slug: 'settings' },
]

export const SOptions: IOption[] = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 20, label: '20' }
]
